import React, { useEffect, useState } from "react";
import "../App.scss";
import { ContentWrap, FlexColumn } from "../styles/Global";
import { Outlet } from "react-router-dom";
import BannerLogo from "../components/BannerLogo";
import { ToastContainer } from "react-toastify";
import { connect, useSelector } from "react-redux";
import { setGlobal } from "../features/global/globalSlice";
import { nativeOwnsAppearance } from "../functions/appearanceOwner";
import { clearModals } from "../features/modals/modalSlice";
import { readStoredJson, writeStoredJson } from "../functions/safeStorage";

const mapDispatch = {
  setGlobal,
  clearModals,
};

const NoNavLayout = ({ hideLogo, setGlobal, clearModals }) => {
  const [viewType, setViewType] = useState(0);
  const global = useSelector((state) => state.global);
  const darkMode = useSelector((state) => state.global.darkMode);
  const params = new URLSearchParams(window.location.search);
  const platform = useSelector((state) => state.organizer.platform);
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const windowLocation = window.location.href;

  window.closeModals = async function () {
    try {
      console.log("closeModals called from window");
      clearModals();
    } catch (error) {
      console.log(error);
      console.log("window.closeModals ERROR: ", error);
    }
  };

  useEffect(() => {
    const localStorageGlobal = JSON.parse(localStorage.getItem("global")) || {};
    console.log("NoNavLayout localStorageGlobal: ", localStorageGlobal);

    const isOverlay =
      new URL(window.location.href).pathname.split("/")[3] === "overlay";
    // SCO-2200: under the new chrome ?mode= is the single source of truth
    const darkMode = isOverlay
      ? false
      : nativeOwnsAppearance()
      ? params.get("mode") === "dark"
      : localStorageGlobal &&
        // window.location.hostname === "localhost" &&
        localStorageGlobal.hasOwnProperty("useCustomTheme") &&
        localStorageGlobal.useCustomTheme
      ? localStorageGlobal.customTheme
      : params.get("mode") !== "light"
      ? params.get("mode") === "dark" ||
        (localStorageGlobal && localStorageGlobal.darkMode)
      : false;
    console.log("NoNavLayout.js darkMode: ", darkMode);

    setGlobal({
      darkMode: darkMode,
      urlParams: params.size > 0 ? params : {},
    });

    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  useEffect(() => {
    console.log("noNavLayout darkMode: ", darkMode);
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);

  // The native menu's Appearance toggle pushes the mode into live webviews (SCO-2200 r4); App.jsx had the hook, this
  // layout's pages (Find a Club, Seasons, …) did not and only re-themed on a reload.
  useEffect(() => {
    window.__setAppearance__ = (mode) => {
      const dark = mode === "dark";
      writeStoredJson("global", { ...readStoredJson("global", {}), darkMode: dark });
      setGlobal({ darkMode: dark });
    };
    return () => {
      delete window.__setAppearance__;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (platform) {
      // console.log("set body class mobile");
      document.body.classList.add("mobile");
    }
  }, [platform]);
  // ?hideBanner=1 (SCO-1809): embedded contexts (the home-events match sheet
  // pushing the scouting report) suppress the Scoreholio banner per-load —
  // hideLogo is per-layout-instance and these routes share one instance.
  const hideBanner = hideLogo || params.get("hideBanner") === "1";

  return (
    // This layout caps at 600px because almost everything on it is a phone-sized
    // webview surface. Godpower and the shared-courts command center are the
    // exceptions — desktop operator tools whose whole job is showing a lot at once.
    <ContentWrap
      maxWidth={
        !["godpower", "shared-courts"].some((wide) =>
          windowLocation.includes(wide),
        ) && "600px"
      }
      // SCO-1870: under native chrome the page owns its rest position — same
      // contract as App.jsx (0 on plain web / unmigrated shells).
      style={{ paddingTop: "var(--sh-chrome-top, 0px)" }}
    >
      <FlexColumn align="center">
        {hideBanner ? null : (
          <BannerLogo
            viewType={viewType}
            disallowChangeSport={sport === "devicelogin"}
            showMainLogo={sport === "devicelogin"}
          />
        )}
        <Outlet />
      </FlexColumn>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </ContentWrap>
  );
};

export default connect(null, mapDispatch)(NoNavLayout);
